import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';

import Filter from './Filter/Filter';
import { FilterDashboardEtat } from './types';

interface DashboardHeaderProps {
  totalCount: number;
  refreshDashboard: () => void;
  setFilter: (value: Partial<FilterDashboardEtat>) => void;
  filter: Partial<FilterDashboardEtat>;
}

export function DashboardHeader({
  totalCount,
  refreshDashboard,
  setFilter,
  filter,
}: DashboardHeaderProps): React.ReactElement {
  const modalCreation = useModal();

  // Il y aura a minima 3 référentiels, un pour chaque valeur d'état
  // donc pas besoin de traité le cas < 1 dans le libellé du compteur
  const countString = `${totalCount} états trouvés`;

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer un état
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
